import { createLogger } from 'shared/services/logger';
import us from '../../defines';
import {Point} from '../../lib/objects';

const logger = createLogger('UScope:extensions:AutoPan');

export function AutoPan (uScope, viewport) {
  // improvemetns:
  //    - instead of moving the div offscreen I could use show/hide like all the other overlays!
  var self = this;
  var isLoaded = false;

  var jVpDiv = viewport.vpDivGet('outer');
  var jAutoPan;

  var timerId = -1; // the autopan timer id

  var autoPanSpecs = { //    autopan settings
    'timerInterval': 50, // timer interval in milliseconds
    'speedFactor': 8, // speed factor - larger number slows pan speed
    'autoPanLT': undefined, // left-top location of center target, Point type, initially undefined
    autoPanCursor: 'url(/viewer/uScope/images/autopan-cur.png), url(/viewer/uScope/images/autopan-cur.cur), auto',
    autoPanCursorOffset: 16 // the hotspot on a cursor is not working so this hard coded offset is used
  };

    // ............................................ off() public
    //    This functions turnsoff autopan.
  this.off = function () {
    if (viewport.navModeGet() == us.eNavModes.nmAutoPan) { self.onOffToggle(); }
  };

  // ............................................ onOffToggle() public
  //    This function toggles autopan on/off.
  this.onOffToggle = function () {
    if (jAutoPan.length == 0) return; // if no match was found, return
    if (isLoaded == false) return;

    // Stop auto-pan when readOnly attribute for a plugin (VP) is true.
    var vpView = viewport.getVPView();
    if (!vpView.isReadOnly && viewport.navModeGet() != us.eNavModes.nmAutoPan) { // if not autopanning, start autopan
      if (autoPanSpecs.autoPanLT === undefined) { // place the autopan image/symbol in the center of the view
        autoPanSpecs.autoPanLT = new Point();
      }

      var vpDivDims = viewport.vpDivDimsGet();
      autoPanSpecs.autoPanLT.x = Math.round((vpDivDims.w - jAutoPan.width()) / 2);
      autoPanSpecs.autoPanLT.y = Math.round((vpDivDims.h - jAutoPan.width()) / 2);
      jAutoPan.css({'left': autoPanSpecs.autoPanLT.x + 'px', 'top': autoPanSpecs.autoPanLT.y + 'px'});

      jVpDiv.addClass(us.clsAPANCUR); // set the autopan cursor
      viewport.navModeSwitch(us.eNavModes.nmAutoPan); // set autopan nav mode
      timerId = setInterval(function () {
        _timer();
      }, autoPanSpecs.timerInterval);
    } else { // if autopanning, halt autopan navigation
      // note: this is called from navmodehalt so do not call back to it!

      clearInterval(timerId); // stop the autopan timer
      timerId = -1;
      jVpDiv.removeClass(us.clsAPANCUR); // return to auto cursor

      // place the autopan image/symbol offscreen//cp-is this better than hiding it?
      jAutoPan.css({'left': us.kDEF_TILE_POS_PX, 'top': us.kDEF_TILE_POS_PX});
    }
  };

  //    This function loads the autopan center-of-the-view image.
  self.init = function () {
    if (jAutoPan) return; // if this viewport already has a autopan div, return

    // first create an offscreen div that will contain the autopan image and add it to the vp
    jAutoPan = $('<div/>', { // build the div tag that contains the img tag
      'class': us.clsAPANDIV + ' ' + us.clsOVERLAY, // overlay class sets the z-index
      css: {'left': us.kDEF_TILE_POS_PX, 'top': us.kDEF_TILE_POS_PX} // locate offscreen
    });
    jVpDiv.append(jAutoPan); // place the autopan div in the vp
    jAutoPan = jVpDiv.find('.' + us.clsAPANDIV); // save for quick access
    isLoaded = true;

    bindEvents_();
  };

  function bindEvents_ () {
    viewport.events.on('viewport:before-zoom-absolute', self.off);
    viewport.events.on('viewport:stop-navigation', navMode => {
      if (navMode === us.eNavModes.nmAutoPan) {
        self.off();
        return true;
      }
    });
    viewport.events.on('state-readonly:change', (isReadOnly) => {
      if (isReadOnly) {
        self.off();
      }
    });
  }

  // ............................................ _timer() local
  //    This function moves the view in proportion to the distance between the cursor and view center.
  var _timer = function () {
    if (viewport.navModeGet() == us.eNavModes.nmAutoPan) {
      // move the image proportional to the distance between the cursor and view center
      var offset = autoPanSpecs.autoPanCursorOffset; // html/js seems to ignore cursor hotspots
      var ptMouse = viewport.getMouseCur();
      var cx = ptMouse.x + offset; // so add offset to correct it
      var cy = ptMouse.y + offset; // so add offset to correct it

      var vpDivDims = viewport.vpDivDimsGet();
      var speedFactor = autoPanSpecs.speedFactor; // move the image dx, dy
      var dx = (cx - vpDivDims.w / 2) / viewport.getViewZoom() / speedFactor;
      var dy = (cy - vpDivDims.h / 2) / viewport.getViewZoom() / speedFactor;
      viewport.moveRelative(dx, dy, us.coordSystemNORM);

      // rotate the autopan autopan center target to point to the cursor
      // - note that the icon's arrow is at 45 degrees so correct for that
      var apAngleDeg = -Math.round(Math.atan2(-dy, dx) * us.Rad2Deg);
      var strAngle = apAngleDeg + 45 + viewport.getViewAngle(true) + 'deg';
      jAutoPan.css({
        'transform': 'rotate(' + strAngle + ')',
        'ms-transform': 'rotate(' + strAngle + ')', /* Internet Explorer  note that the leading '-' is removed */
        '-moz-transform': 'rotate(' + strAngle + ')', /* Firefox */
        '-webkit-transform': 'rotate(' + strAngle + ')', /* Safari and Chrome */
        '-o-transform': 'rotate(' + strAngle + ')' /* Opera */
      });
    } else { // stop this timer!  shouldn't ever happen
      logger.warn('Warning: autopan:_timer: But not in autopan mode - Halting Navigation' + viewport.getImageId());
      viewport.navModeHalt();
    }
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/auto-pan/AutoPan.js